import { useState } from "react";

export type BalanceDecrease = { amount: number; id: number };

export function useBalanceDecrease(value: number | undefined): BalanceDecrease | null {
  const [previous, setPrevious] = useState(value);
  const [decrease, setDecrease] = useState<BalanceDecrease | null>(null);

  if (value !== previous) {
    setPrevious(value);
    if (previous !== undefined && value !== undefined && value < previous)
      setDecrease({ amount: previous - value, id: (decrease?.id ?? 0) + 1 });
  }

  return decrease;
}
